import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "summaryreport";

const initialState = {
  loading: null,
  summaryReportList: [],
  errorMessage: "",
};

//GET
export const getSummaryDetailsFromServer = createAsyncThunk(
  `${namespace}/getSummaryDetailsFromServer`,
  async (customerCode, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/summarydetailsforsummaryreport?customercode=${customerCode}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getSummaryDetailsFromServerByPagination = createAsyncThunk(
  `${namespace}/getSummaryDetailsFromServerByPagination`,
  async (record, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/summaryreportpagination?customercode=${record.customerCode}&pageno=${record.pageNo}&rowsize=${record.rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const summaryReportSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSummaryDetailsFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getSummaryDetailsFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.summaryReportList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getSummaryDetailsFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage;
      })
      .addCase(getSummaryDetailsFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(
        getSummaryDetailsFromServerByPagination.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.errorMessage = null;
        }
      )
      .addCase(
        getSummaryDetailsFromServerByPagination.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.summaryReportList = [];
          state.errorMessage = error.message;
        }
      );
  },
});

export const selectLoadingStatus = (state) => state.summaryreport.loading;
export default summaryReportSlice.reducer;
